var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.catalogues),function(catalogue){return _c('CataloguesCard',{key:catalogue.id,attrs:{"catalogue":catalogue}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }